import MenuItem from '@zenbusiness/zui/MenuItem';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  tag: MenuItem,
  name: 'BusinessEntitySelector',
  slot: 'MenuItem',
  styles: ({ theme, variant }) => ({
    display: 'flex',
    textTransform: 'capitalize',
    alignItems: 'center',
    padding: 0,
    ...theme.typography.body_largeRegular,
    '&:focus': {
      boxShadow: 'none'
    },
    '&:focus-visible': {
      outline: 'none'
    },
    '&:hover, &.Mui-focusVisible, & .active': {
      background: 'rgba(207, 249, 250, 0.4)'
    },
    '& a': {
      textDecoration: 'none',
      color: 'inherit',
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      ...(variant === 'reserved' && {
        width: '100%',
        justifyContent: 'space-between'
      })
    },
    ...(variant === 'view-all' && {
      color: theme.palette.text.tertiary
    })
  })
});
